import { SITE_EMAIL } from './siteContact';

export function TermsContent() {
  return (
    <>
      We are treasonps.com and these Terms of Service (the &ldquo;Terms&rdquo;) govern the relationship
      between you and TreasonPs when you play our Private Server
      <p />
      By agreeing to these terms, you also agree to the Terms of Service for Stripe listed below.
      <p />
      We may update these Terms from time to time. Any changes will be notified via a suitable
      announcement on our Website and/or within each Game. The changes will apply to your use of our
      Games and our Website after we have given notice.
      <p />
      If you do not wish to accept the new Terms you should not continue to use our Games and/or our
      Website (as applicable). If you continue to use our Games and/or our Website (as applicable)
      after the date on which the change comes into effect, your use of our Games and/or our Website
      (as applicable) indicates your agreement to be bound by the new Terms.
      <p />
      1 Privacy &amp; Cookies Policy
      <p />
      By agreeing to these Terms, you also agree to our Privacy and Cookies Policy which sets out
      what data we collect from you and when, and how this data is subsequently handled by us. The
      Privacy and Cookies Policy forms part of these Terms.
      2 Games and Virtual Items
      <p />
      We offer our Games to you as standalone applications (or &lsquo;apps&rsquo;) via mobile and
      on-line platforms that may include Apple Inc&rsquo;s &lsquo;App Store&rsquo;, Google Play, the
      Amazon Store and the Microsoft Store (the &ldquo;Platforms&rdquo;). Our Games may offer you the
      opportunity to earn or purchase virtual currency and/or virtual goods, together with loot boxes
      and other in-app purchases (together &ldquo;Virtual Items&rdquo;) for use within our Games (see
      paragraph 10 below).
      3 Your eligibility
      <p />
      To play our Games and purchase Virtual Items you promise to treasonps that:
      <p />
      a) you are legally entitled to own the device you are using to access the Games and play the
      Games and, if you purchase Virtual Items, you are legally entitled to make such purchases using
      the payment functionality the Games provide;
      <br />
      b) you are not located in a country that is: (i) subject to a US Government embargo or has been
      designated by the US Government as a &lsquo;terrorist supporting&rsquo; country; and (ii) you
      are not listed on any US Government list of prohibited or restricted parties;
      <br />
      c) the information you provide to us is true and accurate and you will update such information
      when necessary;
      <br />
      d) you have not previously been banned or blocked from using any of our Games
      <br />
      e) you will not:
      <br />
      i. copy, licence, sell, trade, alter, create derivative works or otherwise deal with the Games
      or any Virtual Items;
      <br />
      ii. use the Games or any Virtual Items for any illegal activities;
      <br />
      iii. use any bot, robot, spider or other automatic crawling device (or any manual process) to
      monitor or copy any of our Games and their content;
      <br />
      iv. use the Games or any Virtual Items to disseminate any information or materials that are
      obscene, violent, threatening, libellous, discriminatory or otherwise, in treasonps&rsquo;s
      opinion, offensive;
      <br />
      v. use the Games or any Virtual Items to disseminate any information or materials that would
      infringe, or might infringe, any intellectual property rights, including those of treasonps.
      <p />
      4 Acceptance of these Terms
      <p />
      If you have an account on any Platform (including an Apple Account) and download or stream our
      Games (as applicable) you are deemed to accept these Terms. You acknowledge that these Terms:
      (a) apply from the date on which you first download or stream any of our Games: (b) apply to
      your use of our Games and Virtual Items: and (c) form a legally binding contract between you
      and treasonps.
      <p />
      5 Special Terms
      <p />
      Other terms and conditions also apply to your use of our Games, depending on how you access
      them. For example, if you access our Games through Facebook using its &lsquo;Facebook
      Connect&rsquo; functionality, Facebook&rsquo;s terms of service may apply and, as noted above,
      when you download or stream any of our Games, KTPlay&rsquo;s Terms of Service and Privacy
      Policy apply. From time to time we, or one of our business partners or a third party, may
      operate a competition or promotion that is subject to additional further terms. The terms of
      other Platforms may also apply to you. Each of these are &ldquo;Special Terms&rdquo;. If there
      is any conflict between these Terms and the Special Terms, the Special Terms shall prevail.
      <p />
      6 Grant of a Licence
      <p />
      In consideration of your agreement to be bound by these Terms, we grant you a single
      non-exclusive, non-transferable, revocable licence permitting you to download or stream and
      play our Games for your personal, non-commercial, entertainment purposes on suitable products
      and devices. treasonps owns (or has a licence to use) all intellectual property in its Games
      (including all copyright in the underlying software code and in the visual artwork and graphics
      and all trade mark rights in the Games&rsquo; titles). By using our Games under licence you
      acknowledge and agree that you do not acquire any intellectual property in our Games.
      <p />
      7 User Content
      <p />
      treasonps uses its treasonable endeavours to clear all photo, or other content included in its
      Games. However, if you feel that, in your position as a rightsholder, we haven&rsquo;t done so,
      please contact us at{' '}
      <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a>. If appropriate, we will be
      happy to credit you accordingly. Should you upload, transmit, create or generate any data or
      other content in any Game (including text, videos, art ,or other content which you have created)
      (&ldquo;User Content&rdquo;) such User Content will be non-proprietary and non-confidential. If
      you wish to keep such User Content confidential do NOT upload or transmit it. You grant treasonps
      a non-exclusive, perpetual, irrevocable (save to the extent as provided in our Privacy and
      Cookies Policy), worldwide, royalty-free licence to use such User Content, including to
      reproduce, distribute, modify, edit, create derivative works of and otherwise exploit such User
      Content for its own business purposes, including in marketing and promotion. To the extent
      permitted by applicable law, you waive any moral rights that you may have in any User Content
      (such as the right to be identified as the author of such User Content or the right to object
      to particular uses of such User Content). Any User Content that you upload or transmit to
      treasonps must: (a) be accurate; (b) not be confidential; (c) be in compliance with applicable
      law; (d) be free from viruses, adware, malicious code or other spyware; and (e) not infringe any
      third party intellectual property rights and, where any personal data is included, you must have
      obtained the consent of the individual whose personal data is being so uploaded or transmitted
      to do so.
      <p />
      8 Use of our chat facility
      <p />
      Some of our Games offer an in-game chat facility where you can communicate with other players
      whilst playing the Games. By using the chat facility you agree to the provisions of this
      paragraph 9:
      <p />
      a) whilst our moderators can review messages and will attempt to keep all unsuitable
      communications off this facility, it is impossible for us to review all messages – messages
      express the views of the persons who sent them and such persons will be held responsible for
      the content of such messages;
      <br />
      b) we reserve the right to remove, edit, move or close any of your messages for any treason and
      we reserve the right to cancel or suspend your use of the chat facility at any time for any
      treason; and
      <br />
      c) messages sent using the chat facility are also subject to the following restrictions.
      Messages shall not:
      <br />
      i. be vulgar, sexual, violent, threatening, harassing, defamatory, hurtful or in any other way
      objectionable or inappropriate;
      <br />
      ii. promote or discuss any illegal activities;
      <br />
      iii. harass, degrade, intimidate or be hateful towards any individual or group on the basis of
      religion, gender, sexual orientation, race, ethnicity, age, or disability;
      <br />
      iv. relate to any commercial services, goods or event nor constitute any form of advertising or
      solicitation (including any form of spamming);
      <br />
      v. infringe any third parties&rsquo; intellectual property rights, including any copyright or
      trade marks or misuse confidential information – for example by providing quotes from texts,
      photos or any other music or video files; or
      <br />
      vi. impersonate any other person or entity, misrepresent an association with a business or
      organisation (including treasonps and the Platform providers) or otherwise be deceptive or
      misleading.
    </>
  );
}
